<template>
  <div
    v-if="pagination !== null && pagination.data.length > 0"
    class="
      md:flex md:justify-between
      items-center
      md:space-x-5
      space-y-2
      md:space-y-0
      p-5
      mt-3
      md:mt-0
    "
  >
    <!-- Current Range -->
    <div class="text-color-blue text-lg font-bold text-left">
      顯示第&nbsp;&nbsp;{{ startItemNumber }}&nbsp;&nbsp;到&nbsp;&nbsp;{{
        endItemNumber
      }}&nbsp;&nbsp;筆共&nbsp;&nbsp;{{
        pagination.meta.pagination.total
      }}&nbsp;&nbsp;筆資料
    </div>

    <div class="sm:flex items-center justify-center sm:gap-5">
      <!-- Page Input -->
      <div class="flex items-center justify-center">
        <div>&nbsp;&nbsp;</div>
        <input
          type="number"
          min="1"
          :max="pagination.meta.pagination.total_pages"
          v-model="currentPageNumber"
          class="m-2 w-12 text-center border border-gray-200"
          @change="showPage(currentPageNumber)"
        />
        <div>
          &nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;{{
            pagination.meta.pagination.total_pages
          }}頁
        </div>
      </div>

      <div class="flex space-x-5 justify-center">
        <!-- previous page button -->
        <button
          class="back-button"
          @click="showPage(currentPageNumber - 1)"
          :disabled="currentPageNumber === 1 ? true : false"
        >
          上一頁
        </button>

        <!-- next page button -->
        <button
          class="back-button"
          @click="showPage(currentPageNumber + 1)"
          :disabled="
            currentPageNumber === pagination.meta.pagination.total_pages
              ? true
              : false
          "
        >
          下一頁
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pagination"],

  data() {
    return {
      currentPageNumber: 1,
    };
  },

  computed: {
    startItemNumber() {
      return (
        this.pagination.meta.pagination.per_page *
          (this.pagination.meta.pagination.current_page - 1) +
        1
      );
    },

    endItemNumber() {
      if (
        this.pagination.meta.pagination.current_page ===
        this.pagination.meta.pagination.total_pages
      ) {
        return this.pagination.meta.pagination.total;
      } else {
        return (
          this.pagination.meta.pagination.per_page *
          this.pagination.meta.pagination.current_page
        );
      }
    },
  },

  mounted() {
    if (this.pagination !== null) {
      this.currentPageNumber = this.pagination.meta.pagination.current_page;
    }
  },

  methods: {
    showPage(pageNumber) {
      if (pageNumber < 1) {
        this.currentPageNumber = 1;
      } else if (pageNumber > this.pagination.meta.pagination.total_pages) {
        this.currentPageNumber = this.pagination.meta.pagination.total_pages;
      } else {
        this.currentPageNumber = pageNumber;
      }

      this.$emit("changePageNumber", this.currentPageNumber);
    },
  },
};
</script>

<style>
.pagination-item {
  @apply px-2;
}

.pagination-number {
  @apply pagination-item font-extrabold;
}

.pagination-number-link {
  @apply pagination-item text-gray-500;
}

.pagination-number-link:hover {
  @apply text-indigo-900;
}

.pagination-button {
  @apply bg-gray-200 rounded px-5 py-2;
}

.pagination-button:hover {
  @apply bg-gray-300 rounded px-5 py-2;
}

.pagination-button:disabled {
  @apply text-gray-100;
}

.back-button {
  @apply rounded bg-gray-100 px-2 sm:px-5 py-2;
}

.back-button:hover {
  @apply rounded bg-gray-200 px-2 sm:px-5 py-2;
}

</style>
